module.exports = __webpack_public_path__ + "static/media/ethos.88a97dbd.png";